import React, { useState } from "react";
import styled from "styled-components";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";
import GameServices from "./GameServices";
import Loading from "../based/Loading";

function NHLGamePage(props) {
    const [spsIndex, setSpsIndex] = useState({ s1: 1, s2: 0.7, s3: 0.5 });
    const [isBusy, setIsBusy] = useState(false);

    const exportSPS = async () => {
        setIsBusy(true);
        const [err, data] = await GameServices.HandleSPSByGame(spsIndex);
        if (!err) {
            window.open(data.url, "_blank");
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Xuất file thất bại");
        }
        setIsBusy(false);
    };
    return (
        <>
            <Loading show={isBusy} msg={"Đang xử lý API"} />
            <div className="content">
                <Wrapper>
                    <div className="card-box sps p-5 m-auto">
                        <div className="form-box">
                            <h6>SPS</h6>
                            <div className="form-group">
                                <label htmlFor="" className="form-label">
                                    S1
                                </label>
                                <input type="number" className="form-control" value={spsIndex.s1} onChange={(e) => setSpsIndex({ ...spsIndex, s1: +e.target.value })} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="" className="form-label">
                                    S2
                                </label>
                                <input type="number" className="form-control" value={spsIndex.s2} onChange={(e) => setSpsIndex({ ...spsIndex, s2: +e.target.value })} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="" className="form-label">
                                    S3
                                </label>
                                <input type="number" className="form-control" value={spsIndex.s3} onChange={(e) => setSpsIndex({ ...spsIndex, s3: +e.target.value })} />
                            </div>
                            <div className="form-button">
                                <button className="btn btn-primary" onClick={exportSPS}>
                                    Xuất file excel
                                </button>
                            </div>
                        </div>
                    </div>
                </Wrapper>
            </div>
        </>
    );
}

export default NHLGamePage;

const Wrapper = styled.div`
    .card-box.sps {
        width: 1000px;
    }
`;
